import { render, staticRenderFns } from "./ActionPublish.vue?vue&type=template&id=d6820120"
import script from "./ActionPublish.vue?vue&type=script&lang=js"
export * from "./ActionPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports